import { FC } from "react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/cn";

interface SkipLinkProps {
  className?: string;
  targetId?: string;
  children?: React.ReactNode;
}

export const SkipLink: FC<SkipLinkProps> = ({ className, targetId = "main-content", children }) => {
  const { t } = useTranslation("common");
  const label = children ?? t("a11y.skipToContent");
  const handleClick = () => {
    const target = document.getElementById(targetId);
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      className={cn(
        "sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50",
        "focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground",
        "focus:shadow-lg focus:rounded-md",
        className,
      )}
    >
      {label}
    </a>
  );
};
